
















































import VueOptions from '@utils/VueOptions'
import RecessAPI from '@services/RecessAPI'
import Carousel from '@ui/Carousel'

settings =
  name: 'FormFieldUpload'

  vue:
    props: ['value', 'errors', 'uploadParams', 'accept', 'canRemove']

    components: {
      Carousel,
    }

    data: ->
      images: @value
      selectedPhotos: null
      isUploading: false
      widget: null

    computed:
      cloudName: -> process.env.VUE_APP_CLOUDINARY_NAME
      uploadPreset: -> process.env.VUE_APP_CLOUDINARY_PRESET
      endpointUrl: -> "https://api.cloudinary.com/v1_1/#{@cloudName}/image/upload"

      widgetOptions: ->
        cloudName: @cloudName,
        uploadPreset: @uploadPreset,
        cropping: false,
        sources: ['local', 'url']
        multiple: true,
        folder: 'default',
        tags: ['recaps']
        resourceType: 'image',
        clientAllowedFormats: ["jpg", 'png', 'heic', 'gif'],
        # maxImageWidth: 1600

      optionsForCarousel: ->
        uploadPath: @uploadAction
        perPage: if document.body.clientWidth < 768 then 2.25 else 3.5

      actionsForCarousel: ->
        onUpload: @onUploadChange
        remove: @onRemoveImage if @canRemove

    mounted: ->
      @$emit 'focus'
      @widget = cloudinary.createUploadWidget(@widgetOptions, @widgetUploadCompleted)

    methods:
      hiSelectFile: (event) ->
        @selectedPhotos = event.target.files
        @uploadPhotos()

      hiOpenWidget: ->
        @widget.open()

      widgetUploadCompleted: (error, result) ->
        if error
          console.error 'Upload Widget Error:', error

        if result?.event is 'queues-end'
          urls = for file in result.info.files
            file.uploadInfo.eager?[0]?.secure_url || file.uploadInfo.secure_url
          @inputChanged urls

      uploadCompleted: ->
        @isUploading = false
        @inputChanged @images

      uploadPhotos: ->
        @isUploading = true

        formData = new FormData()
        for file, index in @selectedPhotos
          formData.append 'file', file
          formData.append 'upload_preset', @uploadPreset

          try
            response = await fetch @endpointUrl, { method: 'POST', body: formData, }
            data = await response.json()
            @images.unshift(data.eager?[0]?.secure_url || data.secure_url)
          catch
            console.error 'Error:', error
          finally
            @uploadCompleted() if index is @selectedPhotos.length - 1

      inputChanged: (images) ->
        @$emit 'upload', { images, options: @uploadParams }

      onUploadChange: ->
        @inputChanged @images

      onRemoveImage: (url) ->
        @images = @images.filter((image) -> image isnt url)
        @$emit 'input', @images

    watch:
      value: (v) ->
        @images = v

export default VueOptions.vue settings
